import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { noop } from "../../../_util/noop";
import { RowsDraggableTable, RowsDraggableTableBody, DraggableTableRow, } from "./RowsDraggableTable";
import { getRowKeyFromRecordKey } from "../../util/get-row-key-from-record-key";
import { injectPropsIfTargetNotExisted } from "../../util/inject-props-if-target-not-existed";
import { Icon } from "../../../icon";
var fallbackColumnKey = "__row_draggable_addon__";
export function rowsDraggable(_a) {
    var _b = _a.onDragEnd, onDragEnd = _b === void 0 ? noop : _b, _c = _a.onDragStart, onDragStart = _c === void 0 ? noop : _c, _d = _a.draggableRowKeys, draggableRowKeys = _d === void 0 ? "all" : _d, _e = _a.childrenColName, childrenColName = _e === void 0 ? "childrenList" : _e, _f = _a.dragType, dragType = _f === void 0 ? "row" : _f, relations = _a.relations, onExpandedKeysChange = _a.onExpandedKeysChange, expandedKeys = _a.expandedKeys, _g = _a.indent, indent = _g === void 0 ? 20 : _g, _h = _a.hideHandler, hideHandler = _h === void 0 ? "unhover" : _h, icon = _a.icon, _j = _a.width, width = _j === void 0 ? 26 : _j, targetColumnKey = _a.targetColumnKey, options = __rest(_a, ["onDragEnd", "onDragStart", "draggableRowKeys", "childrenColName", "dragType", "relations", "onExpandedKeysChange", "expandedKeys", "indent", "hideHandler", "icon", "width", "targetColumnKey"]);
    var iconColumnWidth = options.iconColumnWidth ||
        (typeof width === "number" ? width : 26);
    var getRowKey;
    var recordsData = [];
    return {
        getInfo: function () { return ({ name: "draggable" }); },
        onInjectProps: function (props) {
            var recordKey = props.recordKey, records = props.records;
            recordsData = records;
            getRowKey = getRowKeyFromRecordKey(recordKey);
            var columns = hideHandler !== true
                ? injectPropsIfTargetNotExisted(props.columns, targetColumnKey, {
                    key: fallbackColumnKey,
                    width: iconColumnWidth,
                    header: null,
                    render: function () { return null; },
                })
                : props.columns;
            return __assign(__assign({}, props), { rowsDraggable: true, draggableRowKeys: draggableRowKeys,
                columns: columns });
        },
        onInjectTable: function (render) { return function (props) {
            var table = render(props);
            return (React.createElement(RowsDraggableTable, { table: table, onDragEnd: onDragEnd, onDragStart: onDragStart, relations: relations, onExpandedKeysChange: onExpandedKeysChange, expandedKeys: expandedKeys, indent: indent, recordsData: recordsData, getRowKey: getRowKey, childrenColName: childrenColName, dragType: dragType, iconColumnWidth: hideHandler !== true && !targetColumnKey ? iconColumnWidth : 0 }));
        }; },
        onInjectBody: function (render) { return function (records, rows, topTip, bottomTip) {
            var body = render(records, rows, topTip, bottomTip);
            return React.createElement(RowsDraggableTableBody, { body: body });
        }; },
        onInjectRow: function (renderRow) { return function (record, rowKey, recordIndex, columns) {
            var key = getRowKey(record, recordIndex);
            var _a = renderRow(record, rowKey, recordIndex, columns), prepends = _a.prepends, row = _a.row, appends = _a.appends;
            // 表头跳过
            if (recordIndex === -1) {
                return { prepends: prepends, row: row, appends: appends };
            }
            return {
                prepends: prepends,
                row: (React.createElement(DraggableTableRow, __assign({}, row.props, { row: row, dataKey: key, key: key, draggableRowKeys: draggableRowKeys }))),
                appends: appends,
            };
        }; },
        onInjectColumn: function (previous) { return function (record, rowKey, recordIndex, column, columnIndex) {
            // 不是目标列
            if (column.key !== targetColumnKey && column.key !== fallbackColumnKey) {
                return previous(record, rowKey, recordIndex, column, columnIndex);
            }
            var _a = previous(record, rowKey, recordIndex, column, columnIndex), children = _a.children, props = _a.props, result = __rest(_a, ["children", "props"]);
            var childrenWrap = children;
            // 非表头
            if (recordIndex !== -1 && hideHandler !== true) {
                childrenWrap = (React.createElement("div", { className: classNames({ "hover-icon": hideHandler === "unhover" }) },
                    React.createElement(Icon, { type: icon }),
                    children));
            }
            return __assign(__assign({}, result), { props: props, children: childrenWrap });
        }; },
    };
}
//# sourceMappingURL=rowsDraggable.js.map